import React, { useEffect, useState } from 'react';
import { OnboardingStageProps } from '../../Classes';
import { Button, Header, Icon, Message } from 'react-frontier';

var OnboardingWelcome = (props: OnboardingStageProps)=>{
	
	return <div className="tp onboarding-welcome">
		<Header text={`¡Hola, ${props.user.first_name}!`} subtext={'Nuevo usuario'} />

		<div className="info">
			<b>¡Te damos la bienvenida a Ebentu!</b> <br />
			A continuación recaudaremos tu información para validarte en nuestro sistema. Te damos un resumen de la información que te pediremos en los siguientes formularios.
		</div>

		<Message>
			<Icon name='circle-user' />
			<div className="info">
				<div className="title">Información general</div>
				<div className="details">Te pediremos tu información general, como tu CURP y RFC, y tu información de contacto.</div>
			</div>
		</Message>
		<Message>
			<Icon name='house-user' />
			<div className="info">
				<div className="title">Domicilio</div>
				<div className="details">Te pediremos tu dirección de domicilio, esta la usaremos para validarte y debe de ser la misma del comprobante que subrirás en la siguiente sección.</div>
			</div>
		</Message>
		<Message>
			<Icon name='id-card' />
			<div className="info">
				<div className="title">Documentos</div>
				<div className="details">Te pediremos una foto de tu identificación oficial asi como foto de tu comprobante de domicilio.</div>
			</div>
		</Message>
		<div className="actions">
			<Button color='black' text='Continuar' onClick={props.onFinish} />
		</div>
	</div>
}

export default OnboardingWelcome;